
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zroblfikoleodbgbuqpu.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inpyb2JsZmlrb2xlb2RiZ2J1cXB1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQzNzkzMzcsImV4cCI6MjA1OTk1NTMzN30.aR3Hi0Da9g5ihN0JyDUSD45HNynWOu1PJcjZfpikdnQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
